module.exports = __webpack_public_path__ + "img/x.e6c7559e.svg";